"use strict";

define('view/board/member.detail',['underscore', 'backbone', 'uikit/uikit', 'libs/format/date', 'model/person'], function (_, Backbone, UIKit, DateFormatter, PersonModel) {
  var dateFormat = DateFormatter('L', 'N/A');
  var PERSON_ATTRIBUTES = [{
    name: 'Alternate',
    field: 'alternates'
  }, {
    name: 'Alternate For',
    field: 'alternatesFor'
  }];
  var LIST_ATTRIBUTES = [{
    name: 'Affiliation',
    field: 'affiliation'
  }];
  var TOKEN_ATTRIBUTES = [{
    name: 'Degrees',
    field: 'degrees'
  }, {
    name: 'Scientific Status',
    field: 'scientificStatus'
  }, {
    name: 'Representation',
    field: 'representation'
  }, {
    name: 'Office',
    field: 'office'
  }];
  var BoardMemberDetailView = UIKit.Form.extend({
    attributes: {
      style: 'margin-top: 2em;'
    },
    initialize: function initialize() {
      UIKit.Form.prototype.initialize.apply(this, arguments);
      var member = this.model;
      errorMessages = new UIKit.Message({
        format: 'error',
        header: 'Something Went Wrong'
      });
      this.errorMessages = errorMessages;
      errorMessages.childBindings.text = 'text';
      errorMessages.collection = new Backbone.Collection();
      var endDateField = new UIKit.Form.Field({
        text: 'End Date',
        visible: !!member.get('endDate')
      });
      endDateField.add(new UIKit.Text({
        name: 'endDate',
        formatter: dateFormat,
        model: member,
        bindings: {
          text: 'endDate'
        }
      }));
      this.add(errorMessages).addGroup({
        autoSize: true
      }).addField({
        text: 'Start Date'
      }, new UIKit.Text({
        name: 'startDate',
        formatter: dateFormat,
        model: member,
        bindings: {
          text: 'startDate'
        }
      })).getOption('parent').add(endDateField).getOption('parent').addField({
        text: 'Alternate'
      }, new UIKit.TokenInput({
        name: 'alternates',
        placeholder: 'Begin typing to search'
      })).getOption('parent').addField({
        text: 'Alternate For'
      }, new UIKit.TokenInput({
        name: 'alternatesFor',
        placeholder: 'Begin typing to search'
      })).getOption('parent').addField({
        text: 'Degrees'
      }, new UIKit.TokenInput({
        name: 'degrees',
        placeholder: ''
      })).getOption('parent').addField({
        text: 'Scientific Status'
      }, new UIKit.TokenInput({
        name: 'scientificStatus'
      })).getOption('parent').addField({
        text: 'Representation'
      }, new UIKit.TokenInput({
        name: 'representation'
      })).getOption('parent').addField({
        text: 'Affiliation'
      }, new UIKit.Dropdown({
        name: 'affiliation',
        placeholder: ''
      })).getOption('parent').addField({
        text: 'Office'
      }, new UIKit.TokenInput({
        name: 'office'
      })).getOption('parent');
      _.each(PERSON_ATTRIBUTES, function (o) {
        this.configurePersonAttribute(this[o.field], o.name, o.field);
      }, this);
      _.each(TOKEN_ATTRIBUTES, function (o) {
        this.configureTokenAttribute(this[o.field], o.name, o.field);
      }, this);
      _.each(LIST_ATTRIBUTES, function (o) {
        this.configureListAttribute(this[o.field], o.name, o.field);
      }, this);
    },
    convertPersonValuesToTokens: function convertPersonValuesToTokens(attributeValues) {
      return attributeValues.map(function (at) {
        var person = new PersonModel(at.get('value'));
        return {
          text: person.get('displayName'),
          textModel: person
        };
      });
    },
    convertStringToTokens: function convertStringToTokens(str) {
      str = String(str || '').trim();
      if (!str) {
        return [];
      }
      return _.map(str.split(/,\s*/), function (t) {
        return {
          text: t
        };
      });
    },
    convertTokensToString: function convertTokensToString(tokens) {
      return tokens.pluck('text').join(', ');
    },
    configureTokenAttribute: function configureTokenAttribute(input, name, field) {
      var member = this.model,
        attributeValue = member.findAttributeValueByName(name);
      input.placeholder = '';
      input.collection.reset(this.convertStringToTokens(attributeValue.get('value')));
      this.listenTo(input, 'token:remove token:add token:revised', _.debounce(function () {
        attributeValue.set('value', this.convertTokensToString(input.collection)).save().promise()["catch"](function (e) {});
        member.trigger('change:' + field);
      }));
    },
    configurePersonAttribute: function configurePersonAttribute(input, name, field) {
      var member = this.model,
        attributeValues = member.filterAttributeValuesByName(name);
      input.collection.reset(this.convertPersonValuesToTokens(attributeValues));
      input.resultsView.childBindings.text = 'displayName';
      input.resultsView.childBindings.description = 'email';
      input.freeText = false;
      this.listenTo(input, 'search:results:text', function (text) {
        input.resultsView.collection = PersonModel.allFinder();
        if (text) {
          input.resultsView.collection.fetch({
            data: {
              q: text
            }
          });
        }
      }).listenTo(input, 'token:add', function (token) {
        var person = token.get('textModel'),
          attributeValue = null;
        attributeValue = member.addAttributeValue(person.id, name);
        attributeValue.save().promise().then(function (d) {
          member.trigger('change:' + field);
          member.findAttributeValueByName('Membership Status').fetch();
          return d;
        })["catch"](function (e) {
          input.collection.remove(token);
          member.get('attributeValues').remove(attributeValue);
        });
      }).listenTo(input, 'token:remove', function (token) {
        var person = token.get('textModel');
        var personValue = member.filterAttributeValuesByName(name).find(function (attributeValue) {
          var value = attributeValue.get('value');
          if (_.isObject(value) && value.id == person.id || value == person.id) {
            return true;
          }
        });
        if (personValue) {
          personValue.destroy({
            wait: true
          }).promise().then(function (d) {
            member.trigger('change:' + field);
            member.findAttributeValueByName('Membership Status').fetch();
            return d;
          })["catch"](function (e) {
            input.collection.add(token);
          });
        }
      });
    },
    configureListAttribute: function configureListAttribute(dropdown, name, field) {
      var member = this.model,
        attributeValue = member.findAttributeValueByName(name),
        choices = attributeValue.get('attribute').get('choices');
      dropdown.collection = choices;
      dropdown.childBindings.text = 'displayName';
      function updateDropdownValue() {
        dropdown.value = choices.find(function (c) {
          if (attributeValue.get('value') == c.get('displayName')) {
            return true;
          }
        });
      }
      ;
      this.listenTo(choices, 'add remove update', _.debounce(updateDropdownValue)).listenTo(dropdown, 'change:value', function () {
        if (dropdown.value) {
          attributeValue.set('value', dropdown.value.get('displayName'));
        }
      }).listenTo(attributeValue, 'change:value', function (model, newValue, oldValue) {
        attributeValue.save().promise().then(function (d) {
          member.trigger('change:' + field);
          return d;
        })["catch"](function (e) {});
      });
      updateDropdownValue();
    }
  });
  return BoardMemberDetailView;
});

